import eventBus from "@/event-bus";
import { loadStorage, saveMainStorage } from "@/utilities/storage/storage-utilities-main";
import { openAlertaV2 } from "@/utilities/services/alert-utilities";
const consola = function () {
  void 0;
};

/**
 * Maneja el resultado de la redirección de Firebase Auth
 * Debe ser llamado al inicializar la aplicación para procesar logins pendientes
 * @param {Object} self - Contexto de Vue con acceso a Firebase y HTTP
 */
const handleRedirectResult = async function(self) {
  try {
    const result = await self.$firebase.auth().getRedirectResult();
    
    if (result.user) {
      // El usuario se autenticó exitosamente via redirección
      window.fake_console('Login exitoso via redirección:', result.user.email);
      
      // Determinar el proveedor basado en los datos del usuario
      const providerId = result.additionalUserInfo?.providerId;
      
      if (providerId === 'google.com') {
        self.$http.defaults.headers["provider"] = "google";
        await processGoogleLogin(self);
      } else if (providerId === 'microsoft.com') {
        self.$http.defaults.headers["provider"] = "microsoft";
        await processMicrosoftLogin(self);
      } else {
        window.fake_console('Proveedor desconocido:', providerId);
      }
    }
  } catch (error) {
    window.fake_console('Error procesando resultado de redirección:', error);
    
    if (window.Sentry) {
      window.Sentry.captureException(error, {
        tags: {
          errorType: 'redirect_result_error'
        },
        extra: {
          errorCode: error.code,
          errorMessage: error.message
        }
      });
    }
  }
};

/**
 * Función de login con Google que implementa fallback de redirección
 * Si el popup es bloqueado, automáticamente usa signInWithRedirect
 * @param {Object} self - Contexto de Vue con acceso a Firebase y HTTP
 */
const LoginWithGoogle = async function (self) {
  try {
    await self.$firebase.auth().setPersistence(self.$firebase.auth.Auth.Persistence.LOCAL);
    const provider = new self.$firebase.auth.GoogleAuthProvider();

    self.$http.defaults.headers["provider"] = "google";
    provider.setCustomParameters({ prompt: "select_account" });

    try {
      // Intentar login con popup primero
      window.fake_console('Intentando login con popup...');
      await self.$firebase.auth().signInWithPopup(provider);
      
      // Si llegamos aquí, el popup funcionó
      await processGoogleLogin(self);
      
    } catch (popupError) {
      window.fake_console('Error con popup:', popupError.code);
      
      // Si el popup fue bloqueado o cerrado, mostrar alerta informativa
       if (popupError.code === 'auth/popup-blocked' || 
           popupError.code === 'auth/popup-closed-by-user' ||
           popupError.code === 'auth/cancelled-popup-request') {
         
         window.fake_console('Popup bloqueado por el navegador');
         await openAlertaV2(
           'Popup Bloqueado', 
           'Su navegador está bloqueando las ventanas emergentes. Por favor, permita los popups para este sitio web en la configuración de su navegador y vuelva a intentar el login.'
         );
         
         // No usar redirección ya que no funciona correctamente con el backend
         // await self.$firebase.auth().signInWithRedirect(provider);
         return;
       } else {
        // Si es otro tipo de error, relanzarlo
        throw popupError;
      }
    }
    
  } catch (error) {
    window.fake_console("EN EL ERROR DE LOGIN");
    window.fake_console(error);
    consola(error);
    window.miconsola("Login Google Error: ", JSON.stringify(error));
    
    // Reportar error específico a Sentry si está disponible
    if (window.Sentry) {
      window.Sentry.captureException(error, {
        tags: {
          errorType: 'google_login_error',
          provider: 'google'
        },
        extra: {
          errorCode: error.code,
          errorMessage: error.message
        }
      });
    }
  }
};

/**
 * Procesa el login de Google después de la autenticación exitosa
 * @param {Object} self - Contexto de Vue
 */
const processGoogleLogin = async function(self) {
  const t = await self.$firebase.auth().currentUser.getIdToken(true);
  consola(t);
  
  self.$http.defaults.headers["Authorization"] = "Bearer " + t;
  const supRequest = await self.$http.post("/login", { dev: self.$deviceUuid, provider: 'google' });
  
  if (!supRequest || !supRequest.data) {
    window.fake_console('Error: Respuesta de login inválida', supRequest);
    if (window.Sentry) {
      window.Sentry.captureException(new Error('Respuesta de login inválida'), {
        tags: { errorType: 'login_response_invalid' },
        extra: { supRequest }
      });
    }
    await openAlertaV2('Error de autenticación', 'No se recibió respuesta válida del servidor. Por favor, intenta nuevamente.');
    return;
  }

  await Login(supRequest.data);
};

/**
 * Función de login con Microsoft que implementa fallback de redirección
 * Si el popup es bloqueado, automáticamente usa signInWithRedirect
 * @param {Object} self - Contexto de Vue con acceso a Firebase y HTTP
 */
const LoginWithMicrosoft = async (self) => {
  try {
    const provider = new self.$firebase.auth.OAuthProvider("microsoft.com");
    self.$http.defaults.headers["provider"] = 'microsoft';

    await self.$firebase.auth().setPersistence(self.$firebase.auth.Auth.Persistence.LOCAL);
    
    provider.setCustomParameters({
      prompt: "select_account",
      tenant: "45de56ea-e505-43a5-bd60-4957c8afc438",
    });

    try {
      // Intentar login con popup primero
      window.fake_console('Intentando login Microsoft con popup...');
      const usr = await self.$firebase.auth().signInWithPopup(provider);
      
      // Si llegamos aquí, el popup funcionó
      window.fake_console("Login Microsoft exitoso: " + JSON.stringify(usr.user.email));
      await processMicrosoftLogin(self);
      
    } catch (popupError) {
      window.fake_console('Error con popup Microsoft:', popupError.code);
      
      // Si el popup fue bloqueado o cerrado, mostrar alerta informativa
       if (popupError.code === 'auth/popup-blocked' || 
           popupError.code === 'auth/popup-closed-by-user' ||
           popupError.code === 'auth/cancelled-popup-request') {
         
         window.fake_console('Popup Microsoft bloqueado por el navegador');
         await openAlertaV2(
           'Popup Bloqueado', 
           'Su navegador está bloqueando las ventanas emergentes. Por favor, permita los popups para este sitio web en la configuración de su navegador y vuelva a intentar el login con Microsoft.'
         );
         
         // No usar redirección ya que no funciona correctamente con el backend
         // await self.$firebase.auth().signInWithRedirect(provider);
         return;
       } else {
        // Si es otro tipo de error, relanzarlo
        throw popupError;
      }
    }
    
  } catch (error) {
    window.fake_console("EN EL ERROR DE LOGIN MICROSOFT");
    window.fake_console(error);
    consola(error);
    window.miconsola("Login Microsoft Error: ", JSON.stringify(error));
    
    // Reportar error específico a Sentry si está disponible
    if (window.Sentry) {
      window.Sentry.captureException(error, {
        tags: {
          errorType: 'microsoft_login_error',
          provider: 'microsoft'
        },
        extra: {
          errorCode: error.code,
          errorMessage: error.message
        }
      });
    }
  }
};

/**
 * Procesa el login de Microsoft después de la autenticación exitosa
 * @param {Object} self - Contexto de Vue
 */
const processMicrosoftLogin = async function(self) {
  const idTokenResult = await self.$firebase.auth().currentUser.getIdTokenResult(true);
  self.$http.defaults.headers["Authorization"] = "Bearer " + idTokenResult.token;

  const supRequest = await self.$http.post("/login", { dev: self.$deviceUuid, provider: 'microsoft' });

  if (!supRequest || !supRequest.data) {
    window.fake_console('Error: Respuesta de login inválida', supRequest);
    if (window.Sentry) {
      window.Sentry.captureException(new Error('Respuesta de login inválida'), {
        tags: { errorType: 'login_response_invalid' },
        extra: { supRequest }
      });
    }
    await openAlertaV2('Error de autenticación', 'No se recibió respuesta válida del servidor. Por favor, intenta nuevamente.');
    return;
  }

  await Login(supRequest.data);
};

const Login = async (roles) => {
  if (!roles || !roles?.tk || !roles?.usr) {
    window.fake_console('Error: Datos de usuario inválidos', roles);
    if (window.Sentry) {
      window.Sentry.captureException(new Error('Datos de usuario inválidos en Login'), {
        tags: { errorType: 'invalid_user_data' },
        extra: { roles }
      });
    }
    await openAlertaV2('Error de sesión', 'No se pudieron cargar los datos de usuario. Por favor, intenta iniciar sesión nuevamente.');
    return;
  }

  const ispdv = new RegExp(/[0-9]{3,4}/g);
  window.fake_console(roles);
  await saveMainStorage(roles.tk, roles.usr, roles.uname, roles.impresoras, roles.geofence, roles.ubiku_rol, roles.pdv || "000", roles.wnumber, roles.racrol);
  const pdv_actual = await loadStorage("pdv");
  const nompos_actual = await loadStorage("nompos");
  const ubiku_recepcion = await loadStorage("ubiku_recepcion");
  const pdv_geoloc = await loadStorage("pdv_geoloc");
  consola(pdv_actual);
  /* chequeo pdv ok  */
  /* consola(pdv_actual, roles.pdv, ispdv.test(pdv_actual) , roles.pdv !=null ? roles.pdv.indexOf(pdv_actual!=-1) : true )
            window.fake_console(pdv_actual, roles, ispdv.test(pdv_actual) , roles.pdv.indexOf(pdv_actual))*/
  const pdvs = roles.tipo === "all" ? true : !roles.pdv ? false : roles.pdv.indexOf(pdv_actual) !== -1;

  window.fake_console(pdv_actual);
  window.fake_console(roles);
  window.fake_console(pdvs);

  if (ispdv.test(pdv_actual) === true && pdvs) {
    window.fake_console("por todos los pdvs ");
    eventBus().emitter.emit("user-logged", roles, pdv_actual, nompos_actual, ubiku_recepcion, pdv_geoloc);
  }
  //else if ( ispdv.test(pdv_actual) === true && roles.pdv.indexOf(pdv_actual) !== -1 )
  else if (ispdv.test(pdv_actual) === true && pdvs) {
    window.fake_console("por pdv concreto ");
    eventBus().emitter.emit("user-logged", roles, pdv_actual, nompos_actual, ubiku_recepcion, pdv_geoloc);
  } else {
    window.fake_console(pdv_actual, roles, pdvs, ispdv.test(pdv_actual));
    window.fake_console("otra situacion ");
    await openAlertaV2("Pdv erroneo", "Pdv no seleccionado o no válido para tus permisos");
  }
};

export { LoginWithGoogle, LoginWithMicrosoft, handleRedirectResult };
